import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import { business, navLinks } from "@/data/site";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-cream/95 backdrop-blur border-b border-charcoal/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <span className="flex items-center justify-center w-10 h-10 bg-rust text-cream font-heading text-2xl leading-none pt-1">
            FR
          </span>
          <span className="leading-none">
            <span className="block font-heading text-2xl sm:text-[28px] text-charcoal tracking-wide">
              Future Roofing
            </span>
            <span className="block font-accent text-[10px] uppercase tracking-[0.22em] text-charcoal/55">
              &amp; Repair · Bucks County, PA
            </span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-accent uppercase text-sm tracking-wide transition-colors ${
                  isActive ? "text-rust" : "text-charcoal/80 hover:text-rust"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={business.phoneHref}
            data-testid="header-call-btn"
            className="hidden sm:flex items-center gap-2 bg-rust text-cream font-heading text-lg uppercase px-4 py-2.5 hover:bg-navy transition-colors"
          >
            <Phone className="w-4 h-4" />
            {business.phone}
          </a>

          {/* Mobile menu */}
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-menu-btn"
                className="lg:hidden flex items-center justify-center w-11 h-11 text-charcoal"
                aria-label="Open menu"
              >
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-cream border-l border-charcoal/10 w-[300px] p-0">
              <div className="bg-charcoal text-cream px-6 py-5">
                <p className="font-heading text-3xl">Future Roofing</p>
                <p className="font-accent text-xs uppercase tracking-widest text-cream/60">
                  &amp; Repair · Bucks County
                </p>
              </div>
              <nav className="flex flex-col p-4">
                {navLinks.map((link) => (
                  <SheetClose asChild key={link.to}>
                    <NavLink
                      to={link.to}
                      data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                      className={({ isActive }) =>
                        `font-accent uppercase tracking-wide text-base px-3 py-3 border-b border-charcoal/10 ${
                          isActive ? "text-rust" : "text-charcoal"
                        }`
                      }
                    >
                      {link.label}
                    </NavLink>
                  </SheetClose>
                ))}
                <a
                  href={business.phoneHref}
                  data-testid="mobile-menu-call"
                  className="mt-5 flex items-center justify-center gap-2 bg-rust text-cream font-heading text-xl uppercase px-4 py-3"
                >
                  <Phone className="w-5 h-5" />
                  Call {business.phone}
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
